"use client";
import "./animatedButton.css";

export default function AnimatedButton({ children, className, onClick }) {
  return (
    <button
      className={className}
      onClick={() =>
        window.open(
          "https://ai.think41.com/login",
          "_blank",
          "noopener,noreferrer"
        )
      }
    >
      {children}
    </button>
  );
}
